import React, { useState } from 'react';
import DialogComponent from '../Dialog';
import Table from '../Table';
import Button, { ButtonContainer } from '../Button';
import Icon from '../Icon';
import { IconsContainer } from './styles'

export default function DialogCalculation({
  formikValues,
  formikRef,
  setFieldValue,
  calcList,
  permissions,
  selectedOption,
  closeModal
}) {
  const [visibleModal, setVisibleModal] = useState({
    visible: true,
  });
  return (
    <DialogComponent forceOnTop show={visibleModal.visible} width="90%">
      <IconsContainer>
        <Icon
          name='close'
          className="icon-close"
          onClick={() => {
            setVisibleModal({ visible: false });
            closeModal && closeModal();
          }}
        />
      </IconsContainer>
      <Table
        formikValues={formikValues}
        formikRef={formikRef}
        calcList={calcList}
        setFieldValue={setFieldValue}
        disabled={true}
        permissions={permissions}
        selectedOption={selectedOption}
        readOnlyMode
      />
      <ButtonContainer style={{ justifyContent: 'flex-end' }}>
        <Button
          id="btnContinue"
          type="button"
          style={{ marginLeft: 15, marginTop: 15, marginBottom: 25 }}
          primary
          onClick={() => {
            setVisibleModal({ visible: false });
            closeModal && closeModal();
          }}
        >
          FECHAR
        </Button>
      </ButtonContainer>
    </DialogComponent>
  )
}